'use client';

import { type ComponentPropsWithRef, type ReactNode } from 'react';

import classnames from 'classnames';
import { IoWarningOutline } from 'react-icons/io5';

import type { BaseComponentProps } from '../../base-component.types';
import { Icon } from '../../icon';
import type { Variant } from '../../shared.types';

import styles from './ActionDialogContent.module.scss';

type ActionDialogContentProps = ComponentPropsWithRef<'div'> &
  BaseComponentProps & {
    icon?: ReactNode;
    iconBg?: Variant;
    title: string;
    badge?: ReactNode;
    media?: ReactNode;
    subtitle?: string;
  };

export function ActionDialogContent({
  ref,
  className,
  icon,
  iconBg = 'neutral',
  title,
  badge,
  media,
  subtitle,
  testId = 'ui-action-dialog-content',
  children,
  ...rest
}: ActionDialogContentProps) {
  return (
    <div
      ref={ref}
      className={classnames(styles['dialog-content'], className)}
      data-testid={testId}
      {...rest}
    >
      {icon !== null && (
        <Icon
          size="lg"
          icon={icon ?? <IoWarningOutline />}
          data-testid={`${testId}_prefix`}
          className={classnames(
            styles['icon'],
            iconBg && styles[`icon--${iconBg}`],
          )}
        />
      )}
      <div className={styles['header']}>
        <div className={styles['title']}>{title}</div>
        {media}
        {badge}
        {subtitle && <div className={styles['subtitle']}>{subtitle}</div>}
      </div>
      <div className={styles['content']}>{children}</div>
    </div>
  );
}
